import { render, staticRenderFns } from "./AntispamAudit.vue?vue&type=template&id=5cbcb6bf&scoped=true"
import script from "./AntispamAudit.vue?vue&type=script&lang=js"
export * from "./AntispamAudit.vue?vue&type=script&lang=js"
import style0 from "./AntispamAudit.vue?vue&type=style&index=0&id=5cbcb6bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbcb6bf",
  null
  
)

export default component.exports